import CreativeInOut from "./ChartCreative.js/CreativeInOut";
// import ChartStatisticsInOut from "./InOutContainer/ChartStatisticsInOut";
// import CreativeReport from "./InOutContainer/CreativeReports";
// import BarChartWeeklyStatistics from "./ChartVehicles/BarChartWeklyStatistics";

const CreativeContainer = () => {
  return <CreativeInOut />;
};

export default CreativeContainer;
